module.exports = __webpack_public_path__ + "img/light.e778675d.png";